<template>
  <div class="bg-blue flex-start">
    <div class="container flex-center">
      <div class="banner"></div>
      <div class="main flex-center">
        <div class="box">
          <div></div>
          <div class="title">东方财富赛事统一管理平台</div>
          <el-form v-if="!$isInnerEnv" class="form-box" @submit.prevent="btnLogin">
            <el-form-item>
              <el-input
                size="large"
                :prefix-icon="Cellphone"
                class="name"
                type="text"
                name="name"
                maxlength="11"
                placeholder="请输入手机号"
                v-model="phoneNum"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="chech-code-input">
              <el-input
                type="text"
                size="large"
                @keyup.enter="btnLogin"
                :prefix-icon="Message"
                maxlength="6"
                placeholder="请输入验证码"
                v-model="msgCode"
              >
                <template #suffix>
                  <div :class="`suffix-box ${limitTime > 0 ? 'active' : ''}`" @click.stop="sendCode">
                    {{ getCheckCodeText }}
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loginLoading" type="primary" size="large" @click="btnLogin" class="login-btn">{{
                loginLoading ? '登录中...' : '登 录'
              }}</el-button>
            </el-form-item>
          </el-form>
          <div v-else class="inner-entry">
            <div class="text">登录</div>
            <div class="white-btn flex-center" @click.stop="handleDongdongLogin">
              <img src="../../assets/img/dclogo.jpg" alt="" />
              <div class="btn-text">咚咚扫码登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-right">Copyright©{{ new Date().getFullYear() }} 东方财富,All Rights Reserved</div>
  </div>
</template>
<script setup lang="ts">
import { Cellphone, Message } from '@element-plus/icons-vue';
import * as api from '@/api';
import { useAsyncLoading } from '@/hooks';
import { userStore } from '@/stores/user';
import { isInnerEnv } from '@/utils/env';
import tools, { rsaEncrypt } from '@/utils/tools';

const phoneNum = ref('');
const useStores = userStore();
const limitTime = ref(0);
const msgCode = ref('');
const getCheckCodeText = ref('获取验证码');
// const loginLoading = ref(false);
const { loading: loginLoading, fn: submitRequest } = useAsyncLoading(() => {
  var data = {
    phoneNum: rsaEncrypt(phoneNum.value),
    msgCode: msgCode.value,
  };
  return api.userManageApi.login(data);
});
const btnLogin = async () => {
  if (phoneNum.value == '') {
    tools.notify('手机号不能为空!', 'warning');
    return;
  }
  if (msgCode.value == '') {
    tools.notify('验证码不能为空!', 'warning');
    return;
  }
  const { userId, userName, token } = await submitRequest();

  useStores
    .login({ token: token, userId, userName })
    .then(() => {
      loginLoading.value = false;
    })
    .catch(err => {
      loginLoading.value = false;
      console.log(err);
    });
};
/** 发送验证码 */
const sendCode = async () => {
  if (phoneNum.value == '') {
    tools.notify('手机号不能为空!', 'warning');
    return;
  }
  if (limitTime.value > 0) return;
  await api.userManageApi.getMsgCode({
    phoneNum: rsaEncrypt(phoneNum.value),
  });
  limitTime.value = 60;
  time();
};
const time = () => {
  if (limitTime.value === 0) {
    getCheckCodeText.value = '获取验证码';
  } else {
    getCheckCodeText.value = limitTime.value + '秒后重新获取';
    limitTime.value--;
    setTimeout(() => {
      time();
    }, 1000);
  }
};

/** 咚咚登录 */
const handleDongdongLogin = () => {
  location.href = dongdongLink.value;
};
const dongdongLink = ref('');
const getDongdongLink = async () => {
  const res = await api.userManageApi.getDongdongLink();
  dongdongLink.value = res.dongdongUri.replace(/10.10.184.99:8803/, `${location.host}`);
};
onMounted(() => {
  if (isInnerEnv) {
    getDongdongLink();
  }
});
</script>
<style scoped lang="scss">
.bg-blue {
  height: 100%;
  background: url('@/assets/img/bg.png') top center/100% 700px no-repeat, #fff;
  overflow-x: auto;
  position: relative;
  .container {
    min-width: 1000px;
    margin: 200px auto 0;
    .banner {
      width: 60%;
      aspect-ratio: 900/565;
      max-width: 600px;
      background: url('@/assets/img/banner.png') center center/100% 100% no-repeat;
    }
    .main {
      flex: 1;
      height: 100%;
      width: 0;
      overflow-x: auto;
      .box {
        width: 100%;
        max-width: 450px;
        min-width: 350px;
        margin: 0 auto;
        background: #ebf6ff;
        padding: 30px;
        text-align: center;
        border-radius: 5px;
        box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        height: 60%;
        min-height: 400px;
        text-align: center;
        padding-top: 60px;
        .inner-entry {
          margin-top: 50px;
          .text {
            color: #323233;
            font-size: 24px;
            text-align: center;
            margin-bottom: 15px;
          }
          .white-btn {
            width: 320px;
            height: 48px;
            margin: auto;
            background: #fff;
            border: 1px solid #dcdee0;
            border-radius: 8px;
            cursor: pointer;
            color: #323233;
            line-height: 48px;
            &:hover {
              background-color: $color-primary;
              color: #fff;
            }
            img {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
        .form-box {
          margin: 0 auto;
          margin-top: 30px;
          .login-btn {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: 20px;
            justify-content: center;
          }
        }
        .title {
          color: $color-primary;
          font-size: 28px;
          font-weight: 600;
        }
        .forget-password {
          font-weight: 400;
          font-size: 15px;
          text-align: right;
          margin-right: 70px;
          cursor: pointer;
        }
        :deep(.chech-code-input) {
          .suffix-box {
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 26px;
            color: #fff;
            padding: 0 8px;
            border-radius: 5px;
            cursor: pointer;
            background-color: $color-primary;

            &.active {
              cursor: default;
              background-color: #bbb;
            }
          }
        }
        .reset-password-dialog .el-dialog__body {
          padding: 20px 20px 10px;
        }
        .reset-password-dialog {
          :deep(.check-code-line) {
            .el-input-group__append {
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
  .copy-right {
    position: absolute;
    background-color: #fff;
    padding: 20px 0 20px;
    width: 100%;
    top: 700px;
    text-align: center;
  }
}
.footer {
  font-size: 14px;
  color: gray;
}
:deep(.el-input--large .el-input__wrapper) {
  padding-right: 0;
}
</style>
